var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntellijIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5656 78.7485L1.10468 59.4954L13.2562 36.9282L48.1328 50.5001L25.5656 78.7485Z",
    fill: "url(#paint0_linear_30_446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 26.9859L99.1062 85.3766L60.2844 101L36.9281 85.85L71.0156 50.5L56.1812 17.675L69.5953 1.57812L101 26.9859Z",
    fill: "url(#paint1_linear_30_446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 26.9859L70.2266 63.2828L56.1813 17.675L69.5953 1.57812L101 26.9859Z",
    fill: "url(#paint2_linear_30_446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6062 83.7984L8.20625 98.475L14.6766 75.75L23.0406 47.6594L0 39.9266L14.6766 0L46.2391 3.7875L77.4859 39.4531L48.6062 83.7984Z",
    fill: "url(#paint3_linear_30_446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0625 18.9375H18.9375V82.0625H82.0625V18.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9344 70.2266H48.6063V74.1719H24.9344V70.2266ZM41.8203 31.8781V27.1438H28.8797V31.8781H32.5094V48.4484H28.8797V53.3406H41.8203V48.4484H38.1906V31.8781H41.8203ZM54.4453 53.6562C52.6436 53.7375 50.8511 53.3573 49.2375 52.5516C47.9174 51.8233 46.7409 50.8607 45.7656 49.7109L49.3953 45.6078C50.0507 46.3279 50.7929 46.964 51.6047 47.5016C52.3686 47.9494 53.245 48.1685 54.1297 48.1328C55.1027 48.2072 56.049 47.7932 56.6547 47.0281C57.3856 46.0867 57.7249 44.8995 57.6016 43.7141V26.8281H63.4406V43.8719C63.5005 45.2677 63.2861 46.6617 62.8094 47.975C62.393 49.3073 61.6306 50.5054 60.6 51.4469C58.8115 52.7747 56.67 53.5434 54.4453 53.6562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_446",
    x1: 1.10468,
    y1: 57.8384,
    x2: 48.0381,
    y2: 57.8384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B07B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#577BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E7CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_446",
    x1: 37.149,
    y1: 35.9181,
    x2: 120.037,
    y2: 54.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#CB7A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9E7B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#757B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#537BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#387CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#237CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#147CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0B7CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_446",
    x1: 91.2157,
    y1: 61.8941,
    x2: 55.915,
    y2: 6.21401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CB417E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9E4E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5365CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#386DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2374E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#1478F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0B7BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_30_446",
    x1: 15.4972,
    y1: 23.7192,
    x2: 100.494,
    y2: 110.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F63462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#DF3A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C24383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#AD4A91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#1D76ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 101,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellijIdea);
export default __webpack_public_path__ + "static/media/intellij-idea.8583d3b1dcc46fb6e21bdf803af080ac.svg";
export { ForwardRef as ReactComponent };